import React from 'react'

type Props = {
  value: number
  maxValue: number
  className?: string
  style?: React.CSSProperties
}

export const ProgressBar = ({ value, maxValue, className = '', style }: Props) => {
  const percentage = Math.round((value / maxValue) * 100)

  return (
    <div className={`c-progress-bar u-bg-white ${className}`} style={style}>
      <div
        className="c-progress-bar__progress u-bg-dark-blue"
        style={{ width: `${percentage}%` }}></div>
    </div>
  )
}

export default ProgressBar
